import React from "react";
import { useTranslation } from "react-i18next";
import VestingBox1 from "../components/VestingBox1";
import VestingBox2 from "../components/VestingBox2";
import VestingBox3 from "../components/VestingBox3";
import VestingBox4 from "../components/VestingBox4";
import Bubble from "../components/Bubble";

import "../styles/vesting.css";

const Vesting = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1 className="vesting-title">{t('vesting.page.title')}</h1>
      <section className="vesting-intro text-content">
        <p className="intro-paragraph">
          {/* Texto removido según lo solicitado */}
        </p>
      </section>

      {/* Primero las cajas de vesting */}
      <div className="vesting-container full-width-container">
        <VestingBox1 />
        <VestingBox2 />
        <VestingBox3 />
        <VestingBox4 />
      </div>

      {/* Espacio adicional entre las cajas y las burbujas */}
      <div style={{ marginTop: '60px' }}></div>

      {/* Burbujas de información después de las cajas */}
      <div className="vesting-bubbles-container" style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '60px', 
        padding: '15px',
        marginBottom: '40px'
      }}>
        {/* Primera fila: Burbujas 1 y 2 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <Bubble 
            className="vesting-info-bubble vesting-info-bubble-1"
            title={t('bubbles.vesting.platform.title')}
            content={t('bubbles.vesting.platform.content')}
            color="blue"
            position="center"
            size="medium"
          />
          <Bubble 
            className="vesting-info-bubble vesting-info-bubble-2"
            title={t('bubbles.vesting.emission.title')}
            content={t('bubbles.vesting.emission.content')}
            color="green"
            position="center"
            size="medium"
          />
        </div>
      </div>
    </>
  );
};

export default Vesting;
